import MovieCard from "@/components/base/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import type { Movie } from "@/types/movie";

export default function RelatedMovies({ movies }: { movies: Movie[] }) {
  if (movies.length === 0) return null;
  return (
    <section>
      <SectionHeading title="相关推荐" subtitle="根据分类、标签与导演为你精选" />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4 xl:grid-cols-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}